import Tooltip, { type TooltipProps } from './tooltip';

export { Tooltip };
export type { TooltipProps };
export default Tooltip;
